import React from 'react';
import { trans, getResourcePath } from '@spotahome/soyuz/client';

import TextImageBlock from '@components/TextImageBlock';

import './CustomerSupportSection.scss';

const imageStyle = {
  height: '413px',
  objectFit: 'cover'
};

const CustomerSupportSection = () => (
  <section className="customer-support-section">
    <div className="customer-support-section__wrapper">
      <TextImageBlock
        imagePosition="right"
        imageSrc={getResourcePath(`/images/landlord/customer-support.jpg`)}
        imageDescription={trans('Lister.landing.page-customer.support.header')}
        title={trans('Lister.landing.page-customer.support.header')}
        content={trans('Lister.landing.page-customer.support.body')}
        alignTo="left"
        imageStyle={imageStyle}
      />
    </div>
  </section>
);

export default CustomerSupportSection;
